import React from "react";
import {
  AlgorithmHeader as Header,
  HeaderCard,
  Heading,
  Padding,
} from "./Styles";
import { Button, Stack, styled } from "@mui/material";
import {
  useParams,
  useLocation,
  useHistory,
} from "react-router-dom/cjs/react-router-dom.min";

import ResavenuePricingSetup from "./ResavenuePricingSetup";
import { useWarning } from "../../Provider/context";
import ResavenueRoomMapping from "./ResavenueRoomMapping";
import StaahRoomMapping from "./StaahRoomMapping";

const ChannelManagerResavenue = ({ isResavenue }) => {
  const { hotelId } = useParams();
  const location = useLocation();
  const history = useHistory();
  const { handleRedirect } = useWarning();

  // Extract search param
  const queryParams = new URLSearchParams(location.search);
  const activeTab = queryParams.get("tab") || "room-mapping"; // default

  const handleTabChange = (tab) => {
    history.push({
      pathname: `/hotel/${hotelId}/setup/channel-manager`,
      search: `?tab=${tab}`,
    });
  };

  return (
    <Wrapper>
      <CustomHeader>
        <CustomHeaderCard>
          <CustomTabNav
            onClick={() => handleTabChange("room-mapping")}
            className={activeTab === "room-mapping" ? "active" : ""}
          >
            <CustomPadding>
              <Heading>Room Mapping</Heading>
            </CustomPadding>
          </CustomTabNav>
        </CustomHeaderCard>

        <HeaderCard>
          <CustomTabNav
            onClick={() => handleTabChange("pricing-setup")}
            className={activeTab === "pricing-setup" ? "active" : ""}
          >
            <Padding>
              <Heading>Pricing Setup</Heading>
            </Padding>
          </CustomTabNav>
        </HeaderCard>
      </CustomHeader>

      <Stack>
        {activeTab === "room-mapping" &&
          (isResavenue ? (
            <ResavenueRoomMapping />
          ) : (
            <StaahRoomMapping isResavenue={isResavenue} />
          ))
          }
        {activeTab === "pricing-setup" && (
          <ResavenuePricingSetup isResavenue={isResavenue} />
        )}
      </Stack>
      <Stack direction="row" gap="16px" justifyContent="end">
        <Button
          variant="contained"
          onClick={() => handleRedirect(`/hotel/${hotelId}/setup/competitors`)}
        >
          Next
        </Button>
      </Stack>
    </Wrapper>
  );
};

export default ChannelManagerResavenue;

// Styled Components
const Wrapper = styled(Stack)`
  gap: 24px;
`;

const CustomHeader = styled(Header)`
  margin-bottom: 0px;
`;

const CustomTabNav = styled("div")`
  &:-webkit-any-link {
    text-decoration: none;
  }

  font: normal normal bold 16px/20px Roboto;
  letter-spacing: 0px;
  color: #727272;

  width: 100%;
  height: 100%;

  &:hover {
    cursor: pointer;
    color: rgb(48, 111, 188);
  }

  &.active {
    color: rgb(48, 111, 188);
    border-left: 4px solid rgb(48, 111, 188);
    background-color: #f9f9f9; /* optional */
  }
`;

const CustomHeaderCard = styled(HeaderCard)`
  margin-top: 0px;
  background: "#ffffff";
  box-shadow: "1px 10px 10px rgba(48, 111, 188, 0.2)";
`;

const CustomPadding = styled(Padding)`
  padding-right: 0px;
`;
